import React from 'react';
import { Icon } from './Icon.js';
export const IconCopy2Fill18 = ({ ...props }) => {
    return (React.createElement(Icon, { size: "18px", ...props },
        React.createElement("path", { d: "M4.75,13h-1c-1.517,0-2.75-1.233-2.75-2.75V4.75c0-1.517,1.233-2.75,2.75-2.75h7.5c1.517,0,2.75,1.233,2.75,2.75v1h-1.5v-1c0-.689-.561-1.25-1.25-1.25H3.75c-.689,0-1.25,.561-1.25,1.25v5.5c0,.689,.561,1.25,1.25,1.25h1v1.5Z", fill: "currentColor", "data-color": "color-2" }),
        React.createElement("rect", { x: "4", y: "5", width: "13", height: "11", rx: "2.75", ry: "2.75", fill: "currentColor" })));
};
//# sourceMappingURL=IconCopy2Fill18.js.map